var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "html-content" }, [
    _c("h2", [_vm._v("Доставка и возврат")]),
    _c("div", {
      domProps: { innerHTML: _vm._s(_vm.GET_FRAGMENT("product_delivery")) }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }